/* eslint-disable no-async-promise-executor */
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import homeService from "../assets/services/home.service";
import rechargeService from "../assets/services/recharge.service";
import reportService from "../assets/services/report.service";
import { MPLAN_BASE, MPLAN_KEY } from "../assets/js/common";
Vue.use(Vuex);
/*
website type
login
both
nologin
*/

export default new Vuex.Store({
  state: {
    _user: {},
    _type: "both",
    _providers: {
      prepaid: [],
      postpaid: [],
      dth: [],
      stv: [],
      broadband: [],
      electricity: [],
      gas: [],
      water: [],
    },
    _states: [],
    _subjects: [],
    _dashboard: {},
    _quick_recharge: null,
  },
  getters: {
    type: (state) => state._type,
    subjects: (state) => state._subjects,
    user: (state) => state._user,
    dashboard: (state) => state._dashboard,
    providers: (state) => state._providers,
    states: (state) => state._states,
    quick_recharge: (state) => state._quick_recharge,
  },
  mutations: {
    SET_QUICK_RECHARGE(state, val) {
      state._quick_recharge = val;
    },
    SET_SUBJECTS(state, val) {
      state._subjects = val.map((item) => {
        return item.subject;
      });
    },
    SET_STATES(state, val) {
      state._states = val.map((item) => {
        return {
          name: item.State,
          value: item.State,
        };
      });
    },
    SET_USER(state) {
      let user = localStorage.user;
      var crypto = require("crypto");
      var AuthKey = crypto.randomBytes(10).toString("hex");
      let doc = { MobileNo: "", Password: "", AuthKey, Source: "JSON" };
      if (user == null) {
        localStorage.user = JSON.stringify(doc);
        state._user = doc;
      } else {
        state._user = JSON.parse(user);
      }
    },
    SET_DASHBOARD(state, val) {
      state._dashboard = val;
    },
    SET_PROVIDERS(state, { key, val }) {
      state._providers[key] = val;
    },
  },
  actions: {
    updateProfile(context, res) {
      let { Email, AuthKey, MobileNo, Password, UserName } = res;
      let doc = {
        MobileNo,
        Password,
        UserName,
        AuthKey: AuthKey,
        Source: "JSON",
        Email,
      };
      localStorage.user = JSON.stringify(doc);
      context.commit("SET_USER");
    },
    fetchBill(context, { offer, tel, type, operator }) {
      return new Promise(async (resolve, reject) => {
        try {
          let base = "ELECTRICITY_INFO";
          if (type == "dth") {
            base = "DTH_CUSTOMER_INFO";
          }
          if (type == "prepaid") {
            base = "ROFFER";
          }
          let url = `${MPLAN_BASE}/${base}?Url=apikey=${MPLAN_KEY}|offer=${offer}|tel=${tel}|operator=${operator}`;
          let { data } = await axios.get(url);
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    fetchStates(context) {
      return new Promise(async (resolve, reject) => {
        try {
          let { data } = await rechargeService.getStateList();
          if (data.data instanceof Object) {
            context.commit("SET_STATES", data.data);
          }
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    fetchQuickRecharge(context) {
      return new Promise(async (resolve, reject) => {
        try {
          let list = context.state._quick_recharge;
          if (list != null) return resolve(list);
          let { data } = await homeService.quickRecharge();
          if (data.data instanceof Array) {
            context.commit("SET_QUICK_RECHARGE", data.data);
          }
          resolve(data.data);
        } catch (error) {
          reject(error);
        }
      });
    },
    fetchPlan(context, { offer, operator, type, circle }) {
      return new Promise(async (resolve, reject) => {
        try {
          let url = `${MPLAN_BASE}/DTH?Url=apikey=${MPLAN_KEY}|offer=${offer}|operator=${operator}`;
          if (type == "prepaid") {
            url = `${MPLAN_BASE}/SIMPLE?Url=apikey=${MPLAN_KEY}|cricle=${circle}|operator=${operator}`;
          }
          let { data } = await axios.get(url);
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    getDashboard(context) {
      return new Promise(async (resolve, reject) => {
        try {
          let { data } = await homeService.dashboard({});
          if (data.data instanceof Object) {
            context.commit("SET_DASHBOARD", data.data);
          }
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    getSubjects(context) {
      return new Promise(async (resolve, reject) => {
        try {
          let { data } = await reportService.getSubjects();
          if (data.data instanceof Array) {
            context.commit("SET_SUBJECTS", data.data);
          }
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    getProviders(context, { params, key }) {
      return new Promise(async (resolve, reject) => {
        try {
          let { data } = await rechargeService.getProviders(params);
          if (data.data instanceof Array) {
            context.commit("SET_PROVIDERS", { key, val: data.data });
          }
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
